import Box, { type BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';

type GridProps = Omit<BoxProps, 'display'>;

const BaseGrid = forwardRef((props: GridProps, ref) => <Box display='grid' {...props} ref={ref} />);
BaseGrid.displayName = 'Grid';

const Grid = styled(BaseGrid)``;

export { Grid };
export type { GridProps };
